const mockUsers = [
  {
    firstName: 'Admin',
    lastName: 'AccessAll',
    username: 'admin',
    password: 'password',
  },
];

export { mockUsers };
